<template>
  <el-popover :hide-after="0" :width="200" placement="bottom" trigger="click">
    <div class="actions-btns-wrap" v-loading="uploading">
      <el-upload
        :ref="(el:any) => (uploadRef = el)"
        v-show="!disabled"
        :http-request="httpRequest"
        :before-upload="beforeUpload"
        :on-success="onFileUploadSuccess"
        :on-change="onFileChangeSuccess"
        :multiple="multiple"
        :show-file-list="false"
      >
        <el-button class="actions-btn">{{
          uploading
            ? `${$t("text.已选")}(${fileUrl.list.length}),${$t(
                "text.上传中"
              )}(${percent * 100})...`
            : $t("actions.本地上传")
        }}</el-button>
      </el-upload>
      <el-button @click="openZoneDialog" class="actions-btn">{{
        uploadStyle == "file"
          ? $t("actions.选择空间文件")
          : $t("actions.选择空间图片")
      }}</el-button>
      <el-button
        v-if="uploadStyle != 'file'"
        @click="openUploadImageByLinkDialog"
        class="actions-btn"
        >{{ $t("actions.使用网络图片") }}</el-button
      >
      <!-- <el-button class="actions-btn">{{
        $t("actions.选择来源图片")
      }}</el-button> -->
    </div>
    <template #reference>
      <slot />
    </template>
  </el-popover>
  <ZoneImageManage
    :ref="(el:any) => (zoneImageManageRef = el)"
    @zone-selected="confirmSelectedImages"
  />
  <UploadImageByLink
    :ref="(el:any) => (uploadImageByLinkRef = el)"
    @add-link-images="onAddLinkSuccess"
  />
</template>
<script lang="tsx">
import type { UnwrapNestedRefs } from "vue";
import { Plus, ArrowDown, Delete } from "@element-plus/icons-vue";
import { defineComponent, computed, reactive, onBeforeMount, h, onMounted, watch, ref } from "vue";
import type { ComputedRef, Ref } from "vue";
import moment from "moment";
import lodash from "lodash-es";
import { useRoute } from "vue-router";
import type { RouteLocationNormalizedLoaded } from "vue-router";
import $ from "jquery";
import OSS from "ali-oss";
import { getOssToken } from "@user-center/api/common";
import _Upload from "element-plus/es/components/upload";
import {
  ElMessageBox,
  ElMessage,
  ElButton,
  ElDropdown,
  ElNotification,
} from "element-plus";
import { useStore, mapGetters } from "vuex";
import type { Store } from "vuex";
import type { StoreStateType } from "@user-center/store/getters";
import type { UserStateType } from "@user-center/store/modules/user";
import { $t } from "@user-center/utils/i18n.ts";
import ZoneImageManage from "./ZoneImageManage.vue";
import UploadImageByLink from "./UploadImageByLink.vue";
export default defineComponent({
  name: "GoodsUploadImageManage",
  props: {
    uploadStyle: {
      type: String,
      default: "image",
    },
    multiple: {
      type: Boolean,
      default: true,
    },

    modelValue: {
      type: String,
      default: "",
    },
    result: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bucket: {
      type: String,
      default: "mps-1302460406",
    } /* 必须 */,
    region: {
      type: String,
      default: "ap-guangzhou",
    } /* 存储桶所在地域，必须字段 */,
    authUrl: {
      type: String,
      default: window.location.origin + "/getUploadToken",
    },
  },
  components: {
    ZoneImageManage,
    UploadImageByLink,
  },
  emits:["uploading-change","update:modelValue","upload-success","zone-selected","add-link-images"],
  setup(props, ctx) {
    let store: Store<StoreStateType> = useStore<StoreStateType>();
    let userinfo: any = computed(() => store.getters.userinfo);
    const state: UnwrapNestedRefs<any> = reactive({
      uploadFiles: lodash.cloneDeep(props.modelValue),
      dialogVisible: false,

      attrList: [
        {
          key: "",
          value: "",
        },
      ],
    });
    const refs: any = {};
    const setRef = (el: any, key: string) => {
      refs[key] = el;
    };

    let fileUrl: UnwrapNestedRefs<any> = reactive({
      list: [],
    });

    let uploading: Ref<boolean> = ref(false);
    let percent: Ref<number> = ref(0);

    let cosObject: OSS;
    let uploadRef: Ref<typeof _Upload | null> = ref(null);
    let zoneImageManageRef: Ref<any> = ref(null);
    let uploadImageByLinkRef: Ref<any> = ref(null);

    watch(
      () => uploading.value,
      (v: any) => {
        ctx.emit("uploading-change", v);
      }
    );
    function beforeUpload(file: File): boolean {
      console.log(file, "beforeUpload");
      // var observable = qiniu.upload(file, key, token, putExtra, config)

      const isPNG = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isJPG = file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (props.uploadStyle == "image") {
        if (!isPNG && !isJPEG && !isJPG) {
          ElMessage.error("上传图片只能是 jpg、png、jpeg 格式!");
          return false;
        }
        if (!isLt2M) {
          ElMessage.error("上传图片大小不能超过 2MB!");
          return false;
        }
      } else if (props.uploadStyle == "file") {
        const isLt200M = file.size / 1024 / 1024 < 200;
        if (!isLt200M) {
          ElMessage.error("上传图片大小不能超过 200MB!");
          return false;
        }
      }
      document.body.click();
      return true;
    }
    let lastOssSign: any = null;
    function getOssTokenFn() {
      return new Promise((resolve, reject) => {
        if (lastOssSign && moment(lastOssSign.expiration).isAfter(moment())) {
          resolve(lastOssSign);
        } else {
          getOssToken()
            .then((sign: any) => {
              resolve(sign);
              lastOssSign = sign;
            })
            .catch((e: any) => {
              reject(e);
            });
        }
      });
    }
    function httpRequest(opt: any): Promise<any> {
      console.log("uploading");
      uploading.value = true;
      return new Promise((resolve, reject) => {
        getOssTokenFn()
          .then((sign: any) => {
            cosObject = new OSS({
              accessKeyId: sign.accessKeyId, // 后台的临时签名ID
              accessKeySecret: sign.accessKeySecret, // 后台的临时签名密钥
              stsToken: sign.securityToken,
              endpoint: sign.endpoint, // 后台配置的 OSS 节点
              bucket: sign.bucket, // 后台配置的 OSS 仓库名
            });

            const curTime = new Date();
            const year = curTime.getFullYear();
            const month = curTime.getMonth() + 1;
            const day = curTime.getDate();
            // 生成日期文件夹 自定义，可根据自身业务 区分文件夹。每个 ‘ / ’ 即是一级目录
            const dir =
              "images/userData/" +
              userinfo.value.id +
              "/" +
              year +
              "-" +
              (month < 10 ? "0" + month : month) +
              "-" +
              (day < 10 ? "0" + day : day) +
              "/";
            let uploadData = {
              key: "",
              name: "",
            };
            // 在文件名中追加时间戳，避免同名文件被覆盖
            const timestamp = Date.now();
            const originName = opt.file.name || "";
            const dotIndex = originName.lastIndexOf(".");
            const hasExt = dotIndex !== -1;
            const baseName = hasExt ? originName.slice(0, dotIndex) : originName;
            const ext = hasExt ? originName.slice(dotIndex) : "";
            uploadData.name = `upload_${userinfo.value.id}_${baseName}_${timestamp}${ext}`;
            cosObject
              .put(dir + uploadData.name, opt.file)
              .then((res) => {
                uploading.value = false;
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err: Error) => {
            uploading.value = false;
            if (err) {
              reject(err);
            }
          });
      });
    }
    function clearFile(): void {
      uploadRef.value && uploadRef.value.clearFiles();
      fileUrl.list = [];
      ctx.emit("update:modelValue", fileUrl.list);
    }

    function onFileUploadSuccess(response: any): void {
      if (response.url && typeof response.url == "string") {
        console.log(uploadRef, "onFileUploadSuccess");
        fileUrl.list.push(response.url);
        ctx.emit("upload-success", response.url);
        ctx.emit("update:modelValue", fileUrl.list);
      } else {
        clearFile();
      }
    }
    function onFileChangeSuccess(e: any, uploadFiles: any[]) {
      console.log(uploadFiles);
      let successAll = true;
      uploadFiles.map((o: any) => {
        if (o.status != "success") {
          successAll = false;
        }
      });
      if (successAll) {
        setTimeout(() => {
          clearFile();
        }, 500);
      }
    }

    function openZoneDialog() {
      if (zoneImageManageRef && zoneImageManageRef.value.openZoneDialog) {
        zoneImageManageRef.value.openZoneDialog();
      }
    }
    function confirmSelectedImages(zoneSelectedImages: any[]) {
      ctx.emit("zone-selected", zoneSelectedImages);
    }
    function onAddLinkSuccess(linkImages: any[]) {
      ctx.emit("add-link-images", linkImages);
    }

    function openUploadImageByLinkDialog() {
      if (uploadImageByLinkRef && uploadImageByLinkRef.value.openDialog) {
        uploadImageByLinkRef.value.openDialog();
      }
    }
    return {
      setRef,
      uploading,
      httpRequest,
      fileUrl,
      beforeUpload,
      onFileUploadSuccess,
      onFileChangeSuccess,
      clearFile,
      percent,
      state,
      openZoneDialog,
      zoneImageManageRef,
      confirmSelectedImages,
      uploadImageByLinkRef,
      openUploadImageByLinkDialog,
      onAddLinkSuccess,
    };
  },
});
</script>
<style lang="scss" scoped>
.actions-btns-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0px;
}
.actions-btn {
  margin: 0 0 5px;
  margin-left: 0 !important;
  width: 150px;
}
.img-list {
  margin: 5px -5px;
}
.pic-item {
  width: 175px;
  box-sizing: border-box;
  display: inline-block;
  background-color: transparent;
  padding: 10px 10px 10px 10px;
  border: 1px solid #ccc;
  font-size: 12px;
  color: #999;
  margin: 5px;
  cursor: pointer;
  &.pic-item-selected {
    border-width: 2px;
    border-color: var(--el-color-primary);

    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      height: 0;
      border-top: 20px solid var(--el-color-primary);
      border-right: 20px solid transparent;
    }
  }
}
.img-box {
  display: block;
  margin: 0 auto;
  width: 150px;
  height: 150px;
}
.img-title {
  font-size: 14px;
  margin: 5px 0 0;
}
</style>
